import type { ModuleStorage } from "app/pages/sales-intelligence/services/storage/types";
import createEducationBarStorage from "app/pages/sales-intelligence/sub-modules/education-bar/services/storage/factory";

export default function createAdvancedSearchPageStorage(storageProvider: ModuleStorage) {
    const educationBarStorage = createEducationBarStorage(storageProvider, {
        isOpenByDefault: false,
    });

    const ownStorage = {};

    return Object.assign(ownStorage, educationBarStorage);
}
